import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import React from 'react';
import {useSponsoredBannerTrackingKey} from './utils/useSponsoredBannerTrackingKey';

export const TrackEmptyBanner: React.FC = () => {
  const trackPromotionKey = useSponsoredBannerTrackingKey(
    TrackingPromotionCreative.BasCategoryHeader,
  );

  return (
    <TrackPromotions
      key={trackPromotionKey}
      disabled={!trackPromotionKey}
      promotion={{
        source: 'monitoring',
        originalSource: TrackingPromotionCreative.BasCategoryHeader,
        advertisement: {
          id: 'monitoring',
          name: 'monitoring',
        },
      }}
      streamPosition={0}
      threshold={0.5}
      triggerOnce
    />
  );
};
